<!-- loading -->
<ng-container *ngIf="loading">
  <span
    class="spinner-border spinner-border-sm"
    role="status"
    aria-hidden="true"
  ></span>
</ng-container>
<form *ngIf="!loading" [formGroup]="form" autocomplete="off">
  <div class="row">
    <!-- thenConditionType -->
    <div class="tw-w-full">
      <list-group-item
        [label]="fields + 'thenConditionType'"
        [value]="thenConditionType | enumToText : thenConditionTypeEnumValues"
      >
      </list-group-item>
    </div>

    <!-- thenConditionValue -->
    <!-- <div class="tw-w-full">
    </div> -->

    <!-- privateNumberId -->
    <div *ngIf="isShowPrivateNumber" class="tw-w-full">
      <list-group-item
        [label]="fields + 'senderNumber'"
        [value]="findPrivateNumber?.number"
      >
      </list-group-item>
    </div>

    <!-- mobileNumber -->
    <div *ngIf="isShowMobileNumber" class="tw-w-full">
      <list-group-item
        [label]="fields + 'mobileNumber'"
        [value]="model?.mobileNumber"
      >
      </list-group-item>
    </div>

    <!-- SentDelayType & SentDelayValue-->
    <div *ngIf="isShowSentDelayType" class="tw-w-full">
      <list-group-item
        [label]="fields + 'sentDelayType'"
        [value]="
          model?.sentDelayType | enumToText : smsSentPeriodTypeEnumValues
        "
      >
      </list-group-item>
    </div>

    <div *ngIf="isShowSentDelayType" class="tw-w-full">
      <list-group-item
        [label]="fields + 'sentDelayValue'"
        [value]="model?.sentDelayValue"
      >
      </list-group-item>
    </div>

    <!--sms body & privateNumber -->
    <div *ngIf="isShowSmsBody" class="tw-w-full">
      <list-group-item
        [label]="fields + 'senderNumber'"
        [value]="findPrivateNumber?.number"
      >
      </list-group-item>

      <div
        class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-200 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 sms-text"
      >
        <div
          class="tw-flex tw-justify-start tw-items-center tw-border-b dark:tw-border-dark-200 tw-pb-2"
        >
          <span class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-100"
            >{{ "common.smsBody" | translate }}
          </span>
        </div>
        <div class="tw-pt-5 tw-text-gray-600 dir-rtl dark:tw-text-gray-300">
          {{ model?.smsBody }}
        </div>
      </div>
    </div>

    <!-- senderPhonebook -->
    <div *ngIf="isShowSenderPhonebook" class="tw-w-full">
      <phonebook-select-search
        type="phonebooksListForServices"
        label="common.group"
        [removable]="false"
        [control]="form?.get('phonebookId')"
        [value]="model.phonebookId"
      >
      </phonebook-select-search>
    </div>

    <!-- email -->
    <div *ngIf="isShowEmail" class="tw-w-full">
      <list-group-item [label]="fields + 'email'" [value]="model?.email">
      </list-group-item>
    </div>

    <!-- phonebooks -->
    <div *ngIf="isShowPhonebooks" class="tw-w-full tw-my-2">
      <div
        class="border border-secondary rounded tw-flex tw-justify-start flex-column"
      >
        <div
          class="tw-flex tw-justify-start tw-items-center tw-bg-gray-100 dark:tw-bg-dark-100/70 tw-rounded-t tw-w-full border-bottom border-secondary tw-px-3 tw-py-4"
        >
          <span class="tw-text-gray-800 dark:tw-text-gray-300 tw-font-medium"
            >{{ "common.group" | translate }}
          </span>
        </div>
        <div class="scroll-div tw-p-3 tw-px-5">
          <div class="row">
            <!-- phonebookItem -->
            <div
              class="md:tw-w-1/3 tw-my-1 tw-rounded"
              *ngFor="let item of phoneBookFilterList"
            >
              <div
                class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-200 tw-rounded-md tw-flex tw-justify-between tw-items-center tw-h-[50px] tw-w-[90px] bg-light"
              >
                <span
                  class="tw-text-gray-800 dark:tw-text-gray-100 tw-font-medium"
                >
                  {{ item.name }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- matching DynamicTemplateId -->
    <div *ngIf="isShowDynamicTemplateId" class="tw-w-full">
      <dynamic-template-select-search
        class="tw-mt-4"
        [label]="fields + 'matchingDynamicTemplateId'"
        [removable]="false"
        [value]="model?.matchingDynamicTemplateId"
        [control]="form?.get('matchingDynamicTemplateId')"
      >
      </dynamic-template-select-search>
    </div>

    <!-- no Matching DynamicTemplateId -->
    <div *ngIf="isShowDynamicTemplateId" class="tw-w-full">
      <dynamic-template-select-search
        class="tw-mt-4"
        [label]="fields + 'noMatchingDynamicTemplateId'"
        [removable]="false"
        [value]="model?.noMatchingDynamicTemplateId"
        [control]="form?.get('noMatchingDynamicTemplateId')"
      >
      </dynamic-template-select-search>
    </div>

    <!-- webhook -->
    <div *ngIf="isShowWebhook" class="tw-w-full tw-mt-3">
      <webhook-select-search
        class="tw-mt-4"
        [removable]="false"
        [value]="model?.webhookId"
        [control]="form?.get('webhookAddress')"
      >
      </webhook-select-search>
    </div>
  </div>
</form>
